module.exports = __webpack_public_path__ + "static/img/wellbore.75e5d9b2.jpeg";